<template>
  <v-toolbar dense>
    <v-btn text small @click="createReport">
      <v-icon left> mdi-pencil </v-icon>
      Nieuw rapport
    </v-btn>

    <v-btn text small color="blue" @click="createLocationReport">
      <v-icon left> mdi-eye-plus </v-icon>
      Gezien Schiphol
    </v-btn>
  </v-toolbar>
</template>

<script>
import { useFormsStore } from "@/stores/formsStore";
import { useReportsStoreRefactor } from "@/stores/reportsStoreRefactor";
import { useDayReportsStoreRefactor } from "@/stores/dayReportsStoreRefactor";
import { useAuthStoreRefactor } from "@/stores/authStoreRefactor";
import { ref, reactive, onMounted } from "vue";
import moment from "moment";

export default {
  name: "ReportButtons",
  props: ["account_id", "day_report_id"],
  setup(props, { emit }) {
    const formsStore = useFormsStore();
    const reportsStore = useReportsStoreRefactor();
    const dayReportsStore = useDayReportsStoreRefactor();
    const authStore = useAuthStoreRefactor();
    const loading = ref(false);

    // Initialize report data with defaults
    const report = reactive({
      report_category: "Communicatie",
      date: moment().format("YYYY-MM-DD"),
      time: moment().format("HH:mm"),
      description: "",
      account_id: props.account_id,
      day_report_id: props.day_report_id,
      duration: 1,
      selected_traits: [],
      user_id: null,
    });

    // Get current user for user_id
    onMounted(async () => {
      try {
        if (!authStore.user) {
          await authStore.getCurrentUser();
        }
        if (authStore.user && authStore.user.id) {
          report.user_id = authStore.user.id;
        }
      } catch (error) {
        console.error("Error initializing ReportButtons:", error);
        // Continue with default values
      }
    });

    const updateReportData = () => {
      // Set current date and time
      report.time = moment().format("HH:mm");
      report.date = moment().format("YYYY-MM-DD");

      // Make sure we have the latest prop values
      report.account_id = props.account_id;

      // Get day_report_id from props or parent
      if (props.day_report_id) {
        report.day_report_id = props.day_report_id;
      }
    };

    const createReport = () => {
      updateReportData();

      console.log("Creating report with basic data:", { ...report });

      formsStore.edit({
        type: "report",
        item: { ...report },
      });
    };

    const createLocationReport = async () => {
      loading.value = true;
      updateReportData();

      try {
        // Set specific values for location report
        report.description = "Schiphol";
        report.report_category = "Locatie";

        console.log("Creating location report with data:", { ...report });

        const createdReport = await reportsStore.create({ ...report });

        // After creating a report, refresh the day report to get updated data
        if (props.day_report_id) {
          await dayReportsStore.getDayReport(props.day_report_id);
          console.log("Day report refreshed after creating report");
        }

        // Reset description
        report.description = "";
        report.report_category = "Communicatie";

        // Notify parent about the new report
        emit("report-created", createdReport);
      } catch (error) {
        console.error("Error creating location report:", error);
      } finally {
        loading.value = false;
      }
    };

    return {
      report,
      loading,
      createReport,
      createLocationReport,
      formsStore,
      reportsStore,
      dayReportsStore,
    };
  },
};
</script>
